export const MIRAGE = '#171D27';
export const WILD_SAND = '#F5F5F5';
export const LOCHMARA = '#0080DE';
export const WHITE = '#fff';
export const BLACK = '#000';
export const TRANSPARENT = 'transparent';
export const DOVE_GRAY = '#6A6A6A';
export const ALTO = '#D1D1D1';

export const CENTER = 'center';

export const FONTS = {
  BOLD: {
    fontFamily: 'Bull',
    fontWeight: 700,
  },
  REGULAR: {
    fontFamily: 'Bull Text',
    fontWeight: 400,
  },
};

export const BASE_SPACING = 20;
export const MAX_WIDTH = 1240;

export const MEDIA_QUERIES = {
  ON_DESKTOP: '@media screen and (min-width: 768px)',
};
